import React, { useState, useEffect } from 'react';
import './Layouts.css'
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
export default function PageLayout() {

    const isScreenLarge = useMediaQuery('(min-width: 900px)');
    return (
        <div className="main-app">
            <Outlet />
            {/* Botón flotante de WhatsApp eliminado de las vistas de detalles de rifa y verificar tickets */}
        </div>
    );
}
